import {
  computed,
  Injectable,
  resource,
  ResourceLoaderParams,
  ResourceRef,
  signal,
  Signal,
  WritableSignal,
} from '@angular/core';
import { firstValueFrom } from 'rxjs';
import { ICity, ICityListRequest } from '@web/dtos';
import { IApiResponse } from '@web/shared-types';
import { CityGateway } from './city.gateway';

@Injectable({
  providedIn: 'root',
})
export class CityStore {
  private readonly gateway: CityGateway = new CityGateway();
  private readonly cityListRequest: WritableSignal<ICityListRequest | null> =
    signal<ICityListRequest | null>(null);

  #cityResource: ResourceRef<IApiResponse<ICity[]> | undefined> = resource({
    params: this.cityListRequest,
    loader: ({
      params,
    }: ResourceLoaderParams<ICityListRequest | null>): Promise<
      IApiResponse<ICity[]> | undefined
    > => {
      return params
        ? firstValueFrom(this.gateway.get(params))
        : Promise.resolve(undefined);
    },
  });
  readonly isLoading: Signal<boolean> = computed((): boolean =>
    this.#cityResource.isLoading()
  );

  readonly cities: Signal<ICity[]> = computed(() => {
    if (this.#cityResource.hasValue()) {
      const data: ICity[] = this.#cityResource.value()
        ?.data as unknown as ICity[];
      return data ?? [];
    }
    return [];
  });

  loadCities(request: ICityListRequest): void {
    this.cityListRequest.set(request);
  }

  reset(): void {
    this.cityListRequest.set(null);
  }

  reload(): void {
    this.#cityResource.reload();
  }
}
